import React from 'react';
import PropTypes from 'prop-types';
import {
  Card,
  CardContent,
  CardHeader,
  Divider,
  Table,
  TableBody,
  Typography,
  Box
} from '@mui/material';
import { QuoteStatus } from 'src/utils/constants/quotes';
import {
  getBuroValidationIconType,
  getBuroValidationStatusText
} from 'src/utils/quotes';
import { useTranslation } from 'react-i18next';
import DetailRow from 'src/components/DetailRow';
import { getClientFullName } from 'src/utils/common';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { selectAuthSystem } from 'src/store/selectors/authSelectors';
import UserType from 'src/utils/constants/auth';
import { formatAmountWithDecimals } from 'src/utils/formatAmout';
import useStyles from '../../styles';

const QuoteClientDetail = ({ quote }) => {
  const { classes } = useStyles();
  const { t } = useTranslation();
  const system = useSelector(selectAuthSystem);

  return (
    <Card variant="elevation">
      <CardHeader
        className={classes.header}
        title={
          <Typography className={classes.tableCell} component="h4" variant="h4">
            {t('CLIENTS_VIEW.CLIENT_DETAIL.TITLE')}
          </Typography>
        }
      />
      <Divider className={classes.tableCell} />
      <CardContent style={{ padding: 0, marginBottom: '16px' }}>
        <Table>
          <TableBody>
            <DetailRow
              name={t('COMMON.CLIENT')}
              value={
                <Link to={`/clients/detail/${quote.client.id}`}>
                  {getClientFullName(quote.client)}
                </Link>
              }
            />

            {system === UserType.ADMIN && (
              <>
                <DetailRow
                  name={t('COMMON.KAM')}
                  value={
                    quote.distributorProfile ? (
                      <Link
                        to={`/distributor-profile/${quote.distributorProfile.id}`}
                      >
                        {quote.distributorProfile.name}
                      </Link>
                    ) : (
                      t('COMMON.NO_DATA')
                    )
                  }
                />
                {quote.clientNufiScore && (
                  <DetailRow
                    name={t('COMMON.NUFI_SCORE')}
                    value={formatAmountWithDecimals(quote.clientNufiScore)}
                  />
                )}
                {quote.buroValidationStatus &&
                  quote.status === QuoteStatus.IN_REVIEW && (
                    <DetailRow
                      name={t('COMMON.PREAUTHORIZATION')}
                      value={
                        <Box
                          sx={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: 1
                          }}
                        >
                          <Typography variant="body2" color="textSecondary">
                            {t(
                              getBuroValidationStatusText(
                                quote.buroValidationStatus
                              )
                            )}
                          </Typography>
                          {getBuroValidationIconType(
                            quote.buroValidationStatus
                          )}
                        </Box>
                      }
                    />
                  )}
              </>
            )}
          </TableBody>
        </Table>
      </CardContent>
    </Card>
  );
};

QuoteClientDetail.propTypes = {
  quote: PropTypes.object.isRequired
};

export default QuoteClientDetail;
